import React, { useEffect, useState } from "react";
import TableDeadline, { AvatarCell, SelectColumnFilter, StatusPill, ImageCell,ProductCell  } from "./TableDeadline"; // new
import { getAuthorization } from "../../../axios/AxiosAut";

function TableDataDeadlines() {
  const [Data, setData] = useState([]);
  const getTableData = () => {
    getAuthorization()
      .get(`dashboard/management/list_upcoming_deadlines/`)
      .then((res) => {
        console.log("table data", res.data
        );
        setData(res.data
          );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getTableData();
    console.log("Data.....", Data);
  }, []);

  const data = [
    {
      status: "Return",
      c_name: "Bulbs",
      id: "#1345cdvbd",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
    {
      status: "",
      c_name: "Cambo",
      id: "#23232cbedf",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
    {
      status: "Return",
      c_name: "Avon Bulbs",
      id: "#334434erer",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
    {
      status: "",
      c_name: "Broardleight Bulbs",
      id: "#43454fcedfd",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
  ];

  const columns = React.useMemo(
    () => [

      {
        Header: "JOB ID",
        accessor: "id",
      },
     
      {
        Header: "Customer",
        accessor: "customer_name",
      },
    
      {
        Header: "Schedule Name",
        accessor: "name",
      },
      {
        Header: "Deadline",
        accessor: "end_date",
       
       
      },
     
      {
        Header: "Status",
        accessor: "status",
        Cell: ProductCell,
      },
    
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <TableDeadline
            columns={columns}
            data={Data == undefined ? [] : Data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableDataDeadlines;
